import { useEffect } from 'react';
import { Link } from 'react-router-dom';
import Navigation from '../../../components/feature/Navigation';
import Footer from '../../../components/feature/Footer';
import FloatingContact from '../../../components/feature/FloatingContact';

export default function SurdurulebilirMimariGelecek() {
  useEffect(() => {
    window.scrollTo(0, 0);
    document.title = 'Sürdürülebilir Mimari ve Geleceğin Yapıları | Levent Atalay';
    
    const metaDescription = document.querySelector('meta[name="description"]');
    if (metaDescription) {
      metaDescription.setAttribute('content', 'Çevre duyarlı tasarım yaklaşımları ve sürdürülebilir malzeme kullanımı modern mimarlığın vazgeçilmez unsurları haline geldi.');
    }
  }, []);

  return (
    <div className="min-h-screen bg-white">
      <Navigation />
      <FloatingContact />
      
      {/* Hero Image */}
      <div className="relative w-full h-96 md:h-[500px] mt-20">
        <img
          src="https://public.readdy.ai/ai/img_res/d372ee826c8a7d74bf90f8d2adf86f34.jpg"
          alt="Sürdürülebilir Mimari"
          className="w-full h-full object-cover object-top"
        />
      </div>

      {/* Article Content */}
      <article className="max-w-3xl mx-auto px-6 py-16">
        {/* Meta */}
        <div className="flex items-center gap-4 text-sm text-gray-500 mb-8">
          <span className="text-gray-900 font-medium">Sürdürülebilirlik</span>
          <span>•</span>
          <span>8 Ocak 2025</span>
          <span>•</span>
          <span>12 dk okuma</span>
        </div>

        {/* Title */}
        <h1 className="font-serif text-4xl md:text-5xl text-gray-900 mb-8 leading-tight">
          Sürdürülebilir Mimari ve Geleceğin Yapıları
        </h1>

        {/* Content */}
        <div className="prose prose-lg max-w-none">
          <p className="text-gray-600 leading-relaxed mb-6">
            İklim değişikliği ve çevre sorunlarının giderek acilleştiği günümüzde, sürdürülebilir mimari artık bir tercih değil, bir zorunluluk haline gelmiştir. Yapı sektörü, küresel karbon emisyonlarının önemli bir bölümünden sorumludur ve bu nedenle çevre duyarlı tasarım yaklaşımları, modern mimarlığın merkezinde yer almaktadır.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Sürdürülebilir Mimarlık Nedir?
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimarlık, çevresel etkileri minimize eden, enerji ve kaynak verimliliğini maksimize eden, kullanıcı sağlığını ve konforunu ön planda tutan bir tasarım yaklaşımıdır. Bu yaklaşım, yapının tüm yaşam döngüsünü dikkate alır: tasarım, inşaat, kullanım ve yıkım aşamalarının her birinde çevresel sorumluluğu gözetir.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimari, sadece teknik çözümlerden ibaret değildir. Aynı zamanda, doğa ile uyumlu yaşam biçimlerini destekleyen, yerel kültür ve iklim koşullarına saygılı, sosyal ve ekonomik sürdürülebilirliği de gözeten bütüncül bir yaklaşımdır.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Enerji Verimliliği
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Enerji verimliliği, sürdürülebilir mimarlığın temel taşlarından biridir. Pasif tasarım stratejileri, yapının enerji ihtiyacını minimize eder. Doğru yönelim, yalıtım, doğal havalandırma ve güneş enerjisinden yararlanma, enerji tüketimini önemli ölçüde azaltır.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Aktif sistemler de enerji verimliliğine katkıda bulunur. Güneş panelleri, ısı pompaları, verimli HVAC sistemleri ve akıllı bina yönetim sistemleri, enerji kullanımını optimize eder. Sıfır enerjili binalar, hatta enerji üreten binalar, artık gerçekleştirilebilir hedeflerdir.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Sürdürülebilir Malzemeler
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Malzeme seçimi, yapının çevresel etkisini doğrudan belirler. Yerel malzemeler, nakliye kaynaklı emisyonları azaltır. Geri dönüştürülmüş ve geri dönüştürülebilir malzemeler, kaynak tüketimini minimize eder. Düşük karbon ayak izine sahip malzemeler, iklim değişikliğiyle mücadelede önemli rol oynar.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Ahşap, sürdürülebilir mimarlıkta öne çıkan bir malzemedir. Yenilenebilir bir kaynak olan ahşap, karbon depolama kapasitesiyle iklim değişikliğine karşı mücadelede etkilidir. Modern ahşap yapı teknolojileri, çok katlı ahşap binaların inşasını mümkün kılmaktadır.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Su Yönetimi
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Su, giderek kıtlaşan değerli bir kaynaktır. Sürdürülebilir mimarlık, su tüketimini azaltan ve su kaynaklarını koruyan stratejiler geliştirir. Yağmur suyu toplama sistemleri, gri su geri dönüşümü ve verimli sulama sistemleri, su kullanımını optimize eder.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Peyzaj tasarımı da su yönetiminde önemli rol oynar. Yerel bitki türleri, az su ihtiyacı olan bitkiler ve geçirgen yüzeyler, su tüketimini azaltır ve yağmur suyunun doğal döngüsüne katılmasını sağlar.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            İç Hava Kalitesi ve Sağlık
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimarlık, kullanıcı sağlığını ön planda tutar. İç hava kalitesi, insan sağlığı ve verimliliği üzerinde doğrudan etkilidir. Düşük VOC emisyonlu malzemeler, etkili havalandırma sistemleri ve bol doğal ışık, sağlıklı iç mekânlar yaratır.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Biyofilik tasarım, doğa ile bağlantıyı güçlendirir. İç mekânlarda bitki kullanımı, doğal malzemeler ve dışarıyla görsel bağlantı, kullanıcıların psikolojik ve fiziksel refahını artırır. Araştırmalar, doğa ile temas halinde olan mekânların stres seviyelerini azalttığını göstermektedir.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Dayanıklılık ve Esneklik
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir yapılar, uzun ömürlü ve esnek olmalıdır. Kaliteli malzemeler ve işçilik, yapının dayanıklılığını artırır. Esnek tasarım, yapının değişen ihtiyaçlara adapte olmasını sağlar ve erken yıkımı önler.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            İklim değişikliğinin etkileri göz önüne alındığında, yapıların iklimsel olaylara karşı dirençli olması da önemlidir. Sel, fırtına ve aşırı sıcaklıklara karşı tasarım stratejileri, yapının uzun vadeli sürdürülebilirliğini garanti eder.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Yerel Bağlam ve Kültür
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimarlık, evrensel ilkelere sahip olsa da, yerel bağlama duyarlı olmalıdır. İklim koşulları, yerel malzemeler, geleneksel yapı teknikleri ve kültürel değerler, tasarım kararlarını şekillendirir.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Vernakular mimarlık, sürdürülebilir tasarım için değerli dersler sunar. Yüzyıllar boyunca gelişen yerel yapı gelenekleri, iklime uygun, kaynak verimli ve kültürel olarak anlamlı çözümler içerir. Modern teknoloji ile geleneksel bilgeliğin birleşimi, güçlü sonuçlar doğurur.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Döngüsel Ekonomi ve Mimarlık
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Döngüsel ekonomi yaklaşımı, atık kavramını ortadan kaldırmayı hedefler. Mimarlıkta bu, yapı elemanlarının yeniden kullanılabilir, geri dönüştürülebilir veya biyolojik olarak parçalanabilir olması anlamına gelir. Tasarım aşamasında, yapının yaşam döngüsü sonunda ne olacağı düşünülür.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Modüler tasarım ve demonte edilebilir bağlantılar, yapı elemanlarının gelecekte yeniden kullanılmasını kolaylaştırır. Bu yaklaşım, hem çevresel hem de ekonomik faydalar sağlar.
          </p>

          <h2 className="font-serif text-2xl md:text-3xl text-gray-900 mt-12 mb-6">
            Sonuç
          </h2>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimari, geleceğin yapılarını şekillendiren temel yaklaşımdır. İklim krizi karşısında, mimarlık mesleği büyük bir sorumluluk taşımaktadır. Çevre duyarlı, enerji verimli, sağlıklı ve uzun ömürlü yapılar tasarlamak, artık bir lüks değil, bir zorunluluktur.
          </p>

          <p className="text-gray-600 leading-relaxed mb-6">
            Sürdürülebilir mimarlık, sadece teknik bir konu değildir. Aynı zamanda, doğa ile uyumlu yaşam biçimlerini destekleyen, sosyal adaleti gözeten ve gelecek nesillere yaşanabilir bir dünya bırakmayı hedefleyen bir felsefedir. Her mimar, her proje, bu dönüşümün bir parçası olabilir ve olmalıdır.
          </p>
        </div>

        {/* Back to Blog */}
        <div className="mt-16 pt-8 border-t border-gray-200">
          <Link
            to="/blog"
            className="inline-flex items-center gap-2 text-gray-900 hover:text-gray-600 transition-colors cursor-pointer whitespace-nowrap"
          >
            <i className="ri-arrow-left-line"></i>
            <span>Tüm Yazılara Dön</span>
          </Link>
        </div>
      </article>

      <Footer />
    </div>
  );
}